export default __webpack_public_path__ + "static/media/lillapappa.8f0a9959.webp";